module.exports = __webpack_public_path__ + "img/work.a2ae7b5d.svg";